"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnualMotorTierChangePanelWidget = void 0;
var React = require("react");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var commonFunctions_1 = require("../../../commonFunctions");
var services_1 = require("@falcon/services");
var core_1 = require("@athena-portal/core");
var components_1 = require("@athena-portal/components");
var AnnualMotorTierChangePanelWidget = exports.AnnualMotorTierChangePanelWidget = /** @class */ (function (_super) {
    __extends(AnnualMotorTierChangePanelWidget, _super);
    function AnnualMotorTierChangePanelWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.calculateAddedAndRemovedDrivers = function () {
            var _a;
            var addedDrivers = (_a = services_1.CommonHelpers.getRemovedAndAddedDrivers(_this.props.interaction.additionalDrivers), _a.addedDrivers), removedDrivers = _a.removedDrivers;
            _this.setState({
                addedDrivers: addedDrivers,
                removedDrivers: removedDrivers
            });
        };
        _this.state = {
            oldInteraction: {},
            loaded: false,
            oldVehicle: {},
            newVehicle: {},
            addedDrivers: [],
            removedDrivers: []
        };
        return _this;
    }
    AnnualMotorTierChangePanelWidget.prototype.componentDidMount = function () {
        var _this = this;
        this.customerPortalService.getPolicy(this.props.interaction.agreementNumber).subscribe(function (policy) {
            _this.setState({
                oldInteraction: policy.interaction,
                loaded: true,
                oldVehicle: policy.interaction.vehicles[0],
                newVehicle: _this.props.engine.getInteraction().vehicles[0],
            }, function () {
                _this.calculateAddedAndRemovedDrivers();
            });
        });
    };
    AnnualMotorTierChangePanelWidget.prototype.render = function () {
        if (!this.state.loaded) {
            return React.createElement(components_1.Overlay, { show: true });
        }
        else {
            return (React.createElement(React.Fragment, null, this.renderOutputPanel()));
        }
    };
    AnnualMotorTierChangePanelWidget.prototype.renderOutputPanel = function () {
        var interaction = this.props.engine.getInteraction();
        var wording = this.getMTASpecificWording(interaction);
        return (React.createElement("div", { className: "panel text-center m-0 tier-change-panel" },
            React.createElement("div", { className: "tier-change-price" },
                React.createElement("p", null,
                    "from ",
                    (0, commonFunctions_1.getAmountToDisplay)(interaction.factors.additionalPremium))),
            React.createElement("p", null, "All figures include Insurance Premium Tax"),
            React.createElement("div", { className: "tier-change-description" },
                "Please check your options below to",
                wording,
                " change your cover level.")));
    };
    AnnualMotorTierChangePanelWidget.prototype.getMTASpecificWording = function (interaction) {
        var process = interaction.process;
        switch (process) {
            case services_1.INTERACTION_PROCESS_SUPPORT_PORTAL_MTA_REPLACE_CAR:
            case services_1.INTERACTION_PROCESS_MTA_REPLACE_CAR:
                return this.getReplaceCarWording(this.state.oldVehicle, this.state.newVehicle);
            case services_1.INTERACTION_PROCESS_SUPPORT_PORTAL_ADD_ADDITIONAL_DRIVER:
            case services_1.INTERACTION_PROCESS_MTA_ADD_TEMPORARY_DRIVER:
            case services_1.INTERACTION_PROCESS_MTA_ADD_PERMANENT_DRIVER:
                return this.getAddDriverWording(interaction);
            default:
                return "";
        }
    };
    AnnualMotorTierChangePanelWidget.prototype.getAddDriverWording = function (interaction) {
        var newAdditionalDriversCount = interaction.additionalDrivers.length - parseInt(window.sessionStorage.getItem("initialAdditionalDriversNumber"), 10);
        var additionalDrivers = interaction.additionalDrivers.slice(-newAdditionalDriversCount);
        var additionalDriversNames = additionalDrivers.map(function (driver, index) {
            return index === additionalDrivers.length - 1 ? "".concat(driver.firstName, " ").concat(driver.lastName) : "".concat(driver.firstName, " ").concat(driver.lastName, ", ");
        });
        var car = interaction.vehicles[0];
        return " add ".concat(additionalDrivers.length === 1 ? "driver" : "drivers", " ").concat(additionalDriversNames, " to\n                    ").concat(car.make, ", ").concat(car.model, " (").concat(car.registrationNumber, ") and");
    };
    AnnualMotorTierChangePanelWidget.prototype.getReplaceCarWording = function (oldVehicle, newVehicle) {
        var oldVehicleElement = "".concat(oldVehicle === null || oldVehicle === void 0 ? void 0 : oldVehicle.make, ", ").concat(oldVehicle === null || oldVehicle === void 0 ? void 0 : oldVehicle.model, " ").concat((oldVehicle === null || oldVehicle === void 0 ? void 0 : oldVehicle.registrationNumber) ?
            "(".concat(oldVehicle === null || oldVehicle === void 0 ? void 0 : oldVehicle.registrationNumber, ")") : "");
        var newVehicleElement = "".concat(newVehicle === null || newVehicle === void 0 ? void 0 : newVehicle.make, ", ").concat(newVehicle === null || newVehicle === void 0 ? void 0 : newVehicle.model, " ").concat((newVehicle === null || newVehicle === void 0 ? void 0 : newVehicle.registrationNumber) ?
            "(".concat(newVehicle === null || newVehicle === void 0 ? void 0 : newVehicle.registrationNumber, ") ") : " ");
        var addedDriversWording = this.state.addedDrivers.length > 0 ?
            " and adding additional ".concat(this.state.addedDrivers.length === 1 ? 'driver' : 'drivers', "\n            ").concat(this.state.addedDrivers, " to ").concat(newVehicleElement) : "";
        var removedDriversWording = this.state.removedDrivers.length > 0 ?
            " and removing ".concat(this.state.removedDrivers.length === 1 ? 'driver' : 'drivers', "\n            ").concat(this.state.removedDrivers, " to ").concat(newVehicleElement) : "";
        return " replace ".concat(oldVehicleElement, " with ").concat(newVehicleElement).concat(addedDriversWording).concat(removedDriversWording, " and");
    };
    __decorate([
        (0, core_1.lazyInject)(services_1.Types.CustomerPortalService),
        __metadata("design:type", Object)
    ], AnnualMotorTierChangePanelWidget.prototype, "customerPortalService", void 0);
    return AnnualMotorTierChangePanelWidget;
}(plugin_journey_1.WidgetBase));
//# sourceMappingURL=AnnualMotorTierChangePanelWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/annual/motor/AnnualMotorTierChangePanelWidget.js
// module id = 3242
// module chunks = 0